import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoAdminRpcClientContext } from "../app/redo-admin-rpc-client-provider";

/** The id of the team's running storefront A/B test, set up in the merchant app; null until loaded. */
export function useActiveStorefrontAbTestId(teamId: string): string | null {
  const rpcClient = useRequiredContext(RedoAdminRpcClientContext);
  const load = useLoad(
    (signal) => rpcClient.getActiveStorefrontAbTest({ teamId }, { signal }),
    [rpcClient, teamId],
  );
  return load.value?.testId ?? null;
}
